import styled from 'styled-components'
export const Wrapper = styled.div`
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -40%);
  z-index: 700;
  width: inherit;
  outline: 0;
  width: 50%;
`

export const Backdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 300;
`

export const StyledModal = styled.div`
  z-index: 100;
  background: white;
  position: relative;
  margin: auto;
  border-radius: 8px;
`

export const Header = styled.div`
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #999;
`

export const HeaderText = styled.div`
  color: #fff;
  align-self: center;
  color: lightgray;
`

export const CloseButton = styled.button`
  font-size: 0.8rem;
  border: none;
  border-radius: 3px;
  margin-left: 0.5rem;
  background: none;
  :hover {
    cursor: pointer;
  }
`

export const Content = styled.div`
  padding: 10px;
  max-height: 43rem;
  overflow-x: hidden;
  overflow-y: auto;
`
